import { sendGAEvent } from '@next/third-parties/google';

export const enum GA_EVENT {
	SEARCH_SUBMISSION = 'search_submission',
	SEARCH_WITHOUT_LOCATION = 'search_without_location',
	LOCATION_CLICK = 'location_click',
	LOCATION_DATA_CLICK = 'location_data_click',
	PICKUP_DATE = 'pickup_date',
	DROPOFF_DATE = 'dropoff_date',
	DIFFERENT_DROPOFF = 'different_dropoff',
	UNCHECK_DIFFERENT_DROPOFF = 'uncheck_different_dropoff',
	DROPOFF_LOCATION_CLICK = 'dropoff_location_click',
	DROPOFF_LOCATION_DATA_CLICK = 'dropoff_location_data_click',
	PICKUP_TIME = 'pickup_time',
	DROPOFF_TIME = 'dropoff_time',
	ADD_TO_CART = 'add_to_cart',
	PRICE_ALERT_SELECT = 'price_alert_select',
	NEWSLETTER_SUBS = 'newsletter_subs',
	CAR_CARD_CLICK = 'car_card_click',
	HOME_PAGE_VIEW = 'home_page_view',
	GOOGLE_SIGN_IN = 'google_sign_in',
}
const enum FB_EVENT {
	SEARCH = 'Search'
}

export const emitGAEventBase = (eventName: GA_EVENT, data?: any) => {
	sendGAEvent('event', eventName, { ...data });
};

export const emitGAEventHomePageView = () => {
	emitGAEventBase(GA_EVENT.HOME_PAGE_VIEW);
};

export const emitGAEventSearchSubmission = () => {
	emitGAEventBase(GA_EVENT.SEARCH_SUBMISSION);
};

export const emitGAEventSearchWithoutLocation = () => {
	emitGAEventBase(GA_EVENT.SEARCH_WITHOUT_LOCATION);
};

export const emitGAEventLocationClick = () => {
	emitGAEventBase(GA_EVENT.LOCATION_CLICK);
};

export const emitGAEventLocationDataClick = (data: {
	region: string;
	country: string;
	city: string;
	title: string;
	type: string;
}) => {
	emitGAEventBase(GA_EVENT.LOCATION_DATA_CLICK, data);
};

export const emitGAEventPickupDate = (date: string) => {
	emitGAEventBase(GA_EVENT.PICKUP_DATE, { date });
};

export const emitGAEventDropoffDate = (date: string) => {
	emitGAEventBase(GA_EVENT.DROPOFF_DATE, { date });
};

export const emitGAEventDifferentDropoff = () => {
	emitGAEventBase(GA_EVENT.DIFFERENT_DROPOFF);
};

export const emitGAEventUncheckDifferentDropoff = () => {
	emitGAEventBase(GA_EVENT.UNCHECK_DIFFERENT_DROPOFF);
};

export const emitGAEventDropoffLocationClick = () => {
	emitGAEventBase(GA_EVENT.DROPOFF_LOCATION_CLICK);
};

export const emitGAEventDropoffLocationDataClick = (data: {
	region: string;
	country: string;
	city: string;
	title: string;
	type: string;
}) => {
	emitGAEventBase(GA_EVENT.DROPOFF_LOCATION_DATA_CLICK, data);
};

export const emitGAEventPickupTime = (time: string) => {
	emitGAEventBase(GA_EVENT.PICKUP_TIME, { time });
};

export const emitGAEventDropoffTime = (time: string) => {
	emitGAEventBase(GA_EVENT.DROPOFF_TIME, { time });
};

export const emitGAEventPriceAlertSelect = (checked: boolean) => {
	emitGAEventBase(GA_EVENT.PRICE_ALERT_SELECT, { checked });
};

export const emitGAEventNewsletterSubs = () => {
	emitGAEventBase(GA_EVENT.NEWSLETTER_SUBS);
};

export const emitGAEventCarCardClick = () => {
	emitGAEventBase(GA_EVENT.CAR_CARD_CLICK);
};

export const emitGAEventGoogleSignIn = () => {
	emitGAEventBase(GA_EVENT.GOOGLE_SIGN_IN);
};

export const emitGAEventSetUserId = (id: string) => {
	if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
		window.gtag('set', {
			user_id: id,
		});
	}
};

export const emitFBEventSetUserId = (id: string) => {
	if (typeof window !== 'undefined' && window.fbq) {
		window.fbq('set', 'userData', { external_id: id });
	}
}

export const emitGAEventAddToCart = (data: {
	origin: string;
	destination: string;
	start_date: string;
	end_date: string;
	google_business_vertical: string;
}) => {
	sendGAEvent('event', GA_EVENT.ADD_TO_CART, {
		items: [data],
	});
};

export const emitGAEventSearch = (data: {
	content_type: string;
	content_id: string;
	city: string;
	region: string;
	country: string;
	travel_start: string;
	travel_end: string;
}) => {
	sendGAEvent('event', FB_EVENT.SEARCH, {
		items: [data],
	});
};

export const emitSearchEventFBEvent = (data: any, eventID?: string) => {
	if (typeof window !== 'undefined' && (window as any).fbq) {
		// Pass eventID (= the user's uid+imid) so Meta can deduplicate this
		// browser event against the server-side (CAPI) Search event and match identity.
		if (eventID) {
			(window as any).fbq('track', FB_EVENT.SEARCH, data, { eventID });
		} else {
			(window as any).fbq('track', FB_EVENT.SEARCH, data);
		}
	}
};
